import { DraftDocument } from './DraftDocument';

export class CacheDraft {
  draftData: DraftDocument;
  indexNextDoc: boolean;
  applyCache: boolean;
}
